<template>
  <section>
    <div v-if="isLoading" class="mt-8 flex justify-center">
      <UISpinner size="xl" />
    </div>
    <div
      v-else-if="hasError"
      class="mt-8 flex flex-col items-center gap-y-[12px] text-center"
    >
      <p class="text-gpx_sm text-gpx_gray-100">
        We couldn't load your subscriptions.
      </p>
      <Button variant="secondary" size="sm" @click="load">Try again</Button>
    </div>
    <ManageSubscriptionsTable
      v-else-if="accountId"
      flush-heading
      :accountId="accountId"
    />
  </section>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import { Button } from '@gpx-spa/ui';
import ManageSubscriptionsTable from '@/components/manage/subscription/list/ManageSubscriptionsTable.vue';
import UISpinner from '@/components/ui/UISpinner.vue';
import { setTitle } from '@/utils/title';
import { useDevice } from '@/composables/useDevice.ts';
import { onMounted, ref } from 'vue';
const store = useStore();

const accountId = store.getters['auth/accountId'];
setTitle('Manage Subscriptions');

const { fetchByAccountId } = useDevice();

const isLoading = ref(true);
const hasError = ref(false);

const load = async () => {
  isLoading.value = true;
  hasError.value = false;
  try {
    await fetchByAccountId(accountId, { device_status: 'active' });
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

onMounted(load);
</script>
